const rootCategoriesIds = [2];

// eslint-disable-next-line import/prefer-default-export
export { rootCategoriesIds };
